import React, { createContext, useContext, useState, ReactNode } from 'react';

interface OrganizationChangeContextType {
  isChanging: boolean;
  setIsChanging: (value: boolean) => void;
}

const OrganizationChangeContext = createContext<OrganizationChangeContextType | undefined>(undefined);

export const useOrganizationChange = () => {
  const context = useContext(OrganizationChangeContext);
  if (!context) {
    throw new Error('useOrganizationChange must be used within OrganizationChangeProvider');
  }
  return context;
};

interface OrganizationChangeProviderProps {
  children: ReactNode;
}

export const OrganizationChangeProvider: React.FC<OrganizationChangeProviderProps> = ({ children }) => {
  const [isChanging, setIsChanging] = useState(false);

  const value = React.useMemo(() => ({
    isChanging,
    setIsChanging
  }), [isChanging]);

  return (
    <OrganizationChangeContext.Provider value={value}>
      {children}
    </OrganizationChangeContext.Provider>
  );
};

